import { useQuery } from '@tanstack/react-query';
import type { IWorkspaceInfo, IWorkspaceTeam } from 'src/@types/workspace-info';
import { TeamRequests } from 'src/requests/team.requests';
import { WorkspaceRequests } from 'src/requests/workspace.requests';
import { queryRetry } from 'src/utils/react-query';
import { workspaceQueryKey } from '../providers/WorkspaceInfo/hooks/common';

export function useWorkspaceInfoQuery() {
  const { data, isFetching, isLoading } = useQuery(
    workspaceQueryKey,
    async () => {
      const [workspace, teams] = await Promise.all([
        WorkspaceRequests.getWorkspaceInfo(),
        TeamRequests.getTeams(),
      ]);
      return {
        workspace,
        teams,
      };
    },
    {
      keepPreviousData: true,
      retry: queryRetry,
      refetchInterval: 30_000,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
      initialData: {
        workspace: {
          _id: '',
          slug: '',
          pendingInvites: [],
          users: [],
          name: '',
          owner: '',
          shortName: '',
          featureSettings: { smartTodos: false },
        } as IWorkspaceInfo,
        teams: [] as IWorkspaceTeam[],
      },
    },
  );

  return {
    data,
    isFetching,
    isLoading,
  };
}
